import { createFileRoute } from "@tanstack/react-router";
import { Flex, Box } from "@radix-ui/themes";
import { Schedules } from "~/components/home/Schedules";
import { DoctorIntro } from "~/components/home/DoctorIntro";
import { Treatments } from "~/components/home/Treatments";
import { HomeConsultForm } from "~/components/home/HomeConsultForm";
import { Hero } from "~/components/Hero";
import { structuredDataScript } from "~/utils/structuredData";

function Index() {
	return (
		<Flex direction="column">
			<Hero />
			<Schedules />
			<DoctorIntro />
			<Treatments />
			<Box width="100%" height="100%" pb="9">
				<HomeConsultForm introductionVariant="homepage" />
			</Box>
		</Flex>
	);
}

export const Route = createFileRoute("/")({
	head: () => ({
		links: [{ rel: "canonical", href: "https://miamibraces.com/" }],
		meta: [
			{ title: "Miami Orthodontic Specialists | Orthodontist in Miami" },
			{
				name: "description",
				content:
					"Get braces, Invisalign, and expert orthodontics in Miami with Miami Orthodontic Specialists. Your trusted orthodontist in Miami. Call now!",
			},
			{
				name: "robots",
				content:
					"index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
			},
			{ property: "og:locale", content: "en_US" },
			{ property: "og:type", content: "website" },
			{
				property: "og:title",
				content: "Miami Orthodontic Specialists | Orthodontist in Miami",
			},
			{ property: "og:url", content: "https://miamibraces.com/" },
			{ property: "og:site_name", content: "Miami Orthodontic Specialists" },
			{
				property: "og:image",
				content: "https://miamibraces.com/miami-ortho-9.jpg",
			},
			{ property: "og:image:width", content: "2000" },
			{ property: "og:image:height", content: "1335" },
			{ property: "og:image:type", content: "image/jpeg" },
			{
				property: "og:image:alt",
				content: "Dr. Garcia-Paul helping a young patient choose braces colors",
			},
			{
				property: "article:publisher",
				content: "https://www.facebook.com/miamibraces/",
			},
			{
				property: "og:description",
				content:
					"Transform your smile with Miami Orthodontic Specialists. Get expert braces & Invisalign treatments in Miami, FL. Schedule a free consultation today!",
			},
			{ name: "twitter:card", content: "summary_large_image" },
			{
				name: "twitter:image",
				content: "https://miamibraces.com/miami-ortho-9.jpg",
			},
			{
				name: "twitter:image:alt",
				content: "Dr. Garcia-Paul helping a young patient choose braces colors",
			},
			{
				name: "twitter:title",
				content: "Miami's Best Orthodontists: Transform Your Smile! #MiamiB",
			},
			{
				name: "twitter:description",
				content:
					"Expert orthodontic care in Miami! Discover top-notch braces & Invisalign treatments #MiamiOrthodontics",
			},
		],
		scripts: [
			structuredDataScript([
				{
					"@context": "https://schema.org",
					"@type": "Dentist",
					name: "Miami Orthodontic Specialists",
					image: "https://miamibraces.com/miami-ortho-logo.png",
					url: "https://miamibraces.com/",
					telephone: "305-407-9000",
					address: {
						"@type": "PostalAddress",
						streetAddress: "8525 SW 92nd Street Suite B-9",
						addressLocality: "Miami",
						addressRegion: "FL",
						postalCode: "33156",
						addressCountry: "US",
					},
					openingHoursSpecification: [
						{
							"@type": "OpeningHoursSpecification",
							dayOfWeek: ["Monday", "Tuesday", "Thursday"],
							opens: "08:30",
							closes: "17:00",
						},
						{
							"@type": "OpeningHoursSpecification",
							dayOfWeek: ["Wednesday", "Friday"],
							opens: "08:30",
							closes: "17:00",
						},
					],
					sameAs: [
						"https://www.facebook.com/miamibraces/",
						"https://www.instagram.com/miamibraces/",
					],
				},
			]),
		],
	}),
	component: Index,
});
